(function () {
  function parseSlides(value, fallback) {
    const parsed = parseFloat(value);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
  }

  function equalizeIngredientCardHeights(root) {
    const cards = root.querySelectorAll('.lp-editorial-ing-cards__card');
    if (!cards.length) return;

    cards.forEach((card) => {
      card.style.minHeight = '';
    });

    let maxHeight = 0;
    cards.forEach((card) => {
      maxHeight = Math.max(maxHeight, card.getBoundingClientRect().height);
    });

    if (maxHeight <= 0) return;

    const height = `${Math.ceil(maxHeight)}px`;
    cards.forEach((card) => {
      card.style.minHeight = height;
    });
  }

  function initIngredientCardsCarousel(root) {
    const swiperEl = root.querySelector('[data-lp-editorial-ing-cards-swiper]');
    if (!swiperEl || root.dataset.lpEditorialIngCardsInit === 'true') return;

    root.dataset.lpEditorialIngCardsInit = 'true';

    const desktopSlides = parseInt(root.dataset.desktopSlides || '4', 10);
    const tabletSlides = parseSlides(root.dataset.tabletSlides, 1.5);
    const mobileSlides = parseSlides(root.dataset.mobileSlides, 1.35);
    const nextEl = root.querySelector('[data-lp-editorial-ing-cards-next]');
    const prevEl = root.querySelector('[data-lp-editorial-ing-cards-prev]');
    const paginationEl = root.querySelector('[data-lp-editorial-ing-cards-pagination]');
    let swiper = null;
    let resizeFrame = null;

    function scheduleEqualize() {
      if (resizeFrame) cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(() => {
        resizeFrame = null;
        equalizeIngredientCardHeights(root);
      });
    }

    function createSwiper() {
      if (typeof Swiper === 'undefined') return;

      const config = {
        resizeObserver: false,
        slidesPerView: mobileSlides,
        spaceBetween: 16,
        watchOverflow: true,
        breakpoints: {
          768: {
            slidesPerView: tabletSlides,
            spaceBetween: 20
          },
          1024: {
            slidesPerView: desktopSlides,
            spaceBetween: 24,
            pagination: paginationEl ? { enabled: false } : undefined
          }
        },
        on: {
          init: scheduleEqualize,
          resize: scheduleEqualize,
          slideChange: scheduleEqualize,
          imagesReady: scheduleEqualize
        }
      };

      if (paginationEl) {
        config.pagination = {
          el: paginationEl,
          clickable: true,
          enabled: true
        };
      }

      if (nextEl || prevEl) {
        config.navigation = {
          nextEl: nextEl || undefined,
          prevEl: prevEl || undefined
        };
      }

      swiper = new Swiper(swiperEl, config);
      scheduleEqualize();
    }

    if (typeof ResizeObserver !== 'undefined') {
      const cardsObserver = new ResizeObserver(scheduleEqualize);
      root.querySelectorAll('.lp-editorial-ing-cards__card-body').forEach((body) => {
        cardsObserver.observe(body);
      });
    }

    window.addEventListener('resize', scheduleEqualize, { passive: true });
    createSwiper();
  }

  function initAll(scope) {
    (scope || document)
      .querySelectorAll('[data-lp-editorial-ing-cards-root]')
      .forEach(initIngredientCardsCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
